import styled from 'styled-components';

export const StyledSalesChart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;
